import { render, staticRenderFns } from "./LoadTypeCreateOrUpdate.vue?vue&type=template&id=2a169d6f&"
import script from "./LoadTypeCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./LoadTypeCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports